
export const products = {
  'product.categories': 'فئات المنتجات',
  'explore.solutions': 'استكشف مجموعتنا الشاملة من حلول AV المهنية',
  'view.video': 'عرض فيديو نظرة عامة على المنتج',
  'AV Over IP': 'AV عبر IP',
  'ReAX Control': 'تحكم ReAX',
  'Meeting Room Solutions': 'حلول غرف الاجتماعات',
  'Converters/Scalers': 'محولات/موائمات',
  'Audio Products': 'منتجات الصوت',
  'HDMI Switchers': 'محولات HDMI',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'منتجات HDBaseT',
  'Complete AV distribution solution with ultra-low latency': 'حل توزيع AV كامل مع زمن استجابة منخفض للغاية',
  'Professional control system solutions': 'حلول أنظمة التحكم المهنية',
  'Complete solutions for modern meeting spaces': 'حلول كاملة لمساحات الاجتماعات الحديثة',
  'Professional format conversion and scaling solutions': 'حلول تحويل وتحجيم التنسيق المهنية',
  'Professional audio processing and playback solutions': 'حلول معالجة وتشغيل الصوت المهنية',
  'Professional HDMI switching and distribution solutions': 'حلول تبديل وتوزيع HDMI المهنية',
  'Advanced IP-based AV distribution platform': 'منصة توزيع AV متقدمة قائمة على IP',
  'Professional HDBaseT distribution solutions': 'حلول توزيع HDBaseT المهنية',
  'group.not.found': 'المجموعة غير موجودة',
  'product.not.found': 'المنتج غير موجود',
  'return.to.home': 'العودة إلى الصفحة الرئيسية',
  'back.to.product.group': 'العودة إلى مجموعة المنتجات',
  'overview': 'نظرة عامة',
  'full.description': 'وصف كامل',
  'features': 'الميزات',
  'specifications': 'المواصفات',
};
